import React, { useState, useEffect, useContext } from 'react';
import {Grid, GridColumn as Column, GridCellProps, GridToolbar, getSelectedState, GridSelectionChangeEvent, GridHeaderCellProps} from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { PageContext } from './PageContext';
import { addUserAssociation, getAdContacts, sendMailMessage } from '../services/apiService';
import { atolUser } from '../services/interfaces';
import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faAddressCard, faInfoCircle, faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { getter } from '@progress/kendo-react-common';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import parse from 'html-react-parser';
import { DropDownList, DropDownListChangeEvent, DropDownListFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { DateTimePicker, DateTimePickerChangeEvent,  } from '@progress/kendo-react-dateinputs';
import { LocalizationProvider,IntlProvider, load, loadMessages } from '@progress/kendo-react-intl';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { mailMessage,userAssociation } from '../services/interfaces';
import UserProfileForm from './UserProfileForm';
import { getSiteFlag, getUniqueUserName,getAdsForBulkEmail,getUserListToAssociate } from '../services/apiService';
import { EmailForm } from './EmailForm';
 interface bulkAd{
        element:string;
        slug:string;
        size:string;
        customer:string;
        tmpChar2:string;
        firstRun:string;
        category:string;
        pubDate:number;
        status:string;
        comment:string;
        comment2:string
    }

export function ContactList (){
    const [contacts, setContacts] = useState<Array<atolUser>>([]);
    const pageContext=useContext(PageContext);
    const userContext=useContext(UserContext);
    const [sendEmailVisible, setSendEmailVisible]=useState(false);
    const [assignCSVisible, setAssignCSVisible]=useState(false);
    const [showContactCard,setShowContactCard]=useState(false);
    const [contactCardVisible, contactCardlVisible]=useState(false);
    const [showContactNote, setShowContactNote] = useState(false);
    const [contactNoteMsg, setContactNoteMsg] = useState("");
    const [selectedContact, setSelectedContact]=useState({});
    const [selectedAds,setSelectedAds]=useState([]);
    const [adsForBulk, setAdsForBulk]=useState<Array<bulkAd>>([]);
    const [commercial, setCommercial]=useState(false);
    const [newUserName,setNewUserName]=useState("");
    const [csSearchVal,setCSSearchVal]=useState("");
    const [csList,setCSList]=useState([]);
    const [mailMessage,setMailMessage]=useState<mailMessage>({
        element:pageContext?.selectedAd.element||"",
        proofType:pageContext?.selectedAd.tmpInt2||0,
        emailBody:"",
        sendTime:new Date(),
        appUser:userContext?.user.username||"",
        operation:"995",
        status:"SENDIT",
        recipient:"",
        user:"",
        key:"",
        includeAds:""
    });
    const [editProfileTitle, setEditProfileTitle]=useState("");
    const [editProfileType, setEditProfileType]=useState("");
    const [contactsSelected, setContactsSelected] = useState<atolUser[]>([]);
    const [action,setAction]=useState("Edit");
    
    const hideAssignCS=()=>{
        setCSList([]);
        setAssignCSVisible(false);
    }

    const showAssignCS=()=>{
        setAssignCSVisible(true);
    }

    const togglShowEmail=()=>{
        setSendEmailVisible(!sendEmailVisible);
    }
    const toggleShowContactNote=()=>{
        setShowContactNote(!showContactNote);
    }

    const setCSSearch=(e:DropDownListFilterChangeEvent)=>{
        console.log(e.filter.value);
        if (e.filter.value.length>4){
            getUserListToAssociate(e.filter.value).then(data=>{
                setCSList(data);
            });
        }
    }

    const setSelectedCS=(e:DropDownListChangeEvent)=>{
        console.log("Set Selected CS");
        console.log(e.value);
        setNewUserName(e.value.id);
    }

    const assignCS=()=>{
        console.log("Assign to CS");
        console.log(newUserName);
        var association:userAssociation={
            username:"",
            association:"",
            security:"",
            expires:""
        };
        association.username=newUserName;
        association.association=pageContext?.selectedAd.fileSize2||"";
        association.security="3C";
        addUserAssociation(association).then(data=>{
            console.log(data);
            const element = pageContext?.selectedAd.element;
            if (element){
                getAdContacts(element).then(data=>{
                    console.log(data);
                    setContacts(data);
                    hideAssignCS();
                });
            }
        })
    }

    const [selectedState, setSelectedState] = React.useState<{
            [id: string]: boolean | number[];
        }>({});

    const [bulkSelectedState, setBulkSelectedState] = React.useState<{
            [id: string]: boolean | number[];
        }>({});

    const idGetter = getter("userName");
    const bulkIdGetter = getter("element");

    const getContacts=()=>{
        const element = pageContext?.selectedAd.element;
        if (element){
            getAdContacts(element).then(data=>{
                console.log(data);
                setContacts(data);
            });
        }
    }

    const emailThisContact=(contact: atolUser) => {
        console.log("Emailing contact:", contact);
        setSelectedContact(contact);
        setContactsSelected([...contactsSelected,contact]);
        setBulkSelectedState({});
        setSendEmailVisible(true);
        // Add logic to handle emailing the contact
    }

    const showNewCustContact=()=>{
        const userSec = userContext?.user.type||0;
        const enabled = pageContext?.glSettings.EnableNewCustomerContact;
        //console.log ("User Type:" + userSec);
        //console.log ("Enabled:" + enabled);
        const allowedTypes=[1,2,4,5];
        if (userSec==1||userSec==2||userSec==4||userSec==5){
            //console.log("Allowed for this security");
            return (enabled);
        }else{
            return (false);
        }
    }

    const showEmailSelected=()=>{
        const userSec = userContext?.user.type||0;
        console.log("UserSec=" + userSec);
        if (userSec==1||userSec==2||userSec==4||userSec==5){
            return (true);
        }else{
            return (false);
        }
    }

    const contactButtons = (props: GridCellProps) => {
        return (
            <td>
                <a href="#" onClick={() => emailThisContact(props.dataItem)}><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon></a>
                &emsp;
                <a href="#" onClick={() => showContactInfo(props.dataItem)}><FontAwesomeIcon icon={faAddressCard}></FontAwesomeIcon></a>
            </td>
        );
    }

    const formatType = (props:GridCellProps)=>{
        var type = "";
        switch(props.dataItem.security){
            case 0:
                type="Customer";
                break;
            case 1:
                type="Sales";
                break;
            case 2:
                type="Assist";
                break;
            case 3:
                if (props.dataItem.temp2=="C"){
                    type="CS";
                }else{
                    type="Agency";
                }
                break;
            case 4:
                type="Manager";
                break;
        }
        return(<td>{type}</td>);
    }

    const isCommercial=()=>{
        if (pageContext?.selectedAd){
            getSiteFlag(pageContext.selectedAd.file1).then((data:{site_Flag1:string, contact_Phone:string}[]) => {
                if (data.length>0) {
                    //var objFlag = JSON.parse(data);
                    if (data[0].site_Flag1 == "C") {
                        setCommercial(true);
                    }
                }
            })            
        }
    }


    const newContactInfo=async ()=>{
        setAction("New")
        setEditProfileTitle("New Customer Contact");
        setEditProfileType("New");
        const newContact:atolUser={
            fullName:"",
            customer:pageContext?.selectedAd.customer||"",
            email:"",
            phone:"",
            fax:"",
            userName:"",
            password:"",
            rep_id:0,
            security:0,
            temp1:"",
            temp2:pageContext?.selectedAd.fileSize2||"",
            temp3:"",
            temp4:"",
            //temp4:pageContext?.selectedAd.file1||"",
            temp5:"",
            temp6:"",
            temp7:"",
            salt:0,
            apiKey:"",
            proof_email:false,
            insert_email:false,
            submit_email:false,
            correction_email:false,
            approval_email:false,
            associations:"",
            trusted: commercial ? 1 : 0,
            superUser:false
        }
        setSelectedContact(newContact);
        setShowContactCard(true);
    }

    const showContactInfo=(contact: atolUser)=>{
        setAction("Edit");
        setEditProfileTitle("Edit Contact Info");
        setEditProfileType("Edit");
        setSelectedContact(contact);
        setShowContactCard(true);
    }

    const hideContactInfo=()=>{
        setSelectedContact({});
        setShowContactCard(false);
        getContacts();
    }


    const onSelectionChange = React.useCallback(
        (event: GridSelectionChangeEvent) => {

            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: "userName"
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );

    const onBulkSelectionChange = React.useCallback(
        (event: GridSelectionChangeEvent) => {

            const newBulkSelectedState = getSelectedState({
                event,
                selectedState: bulkSelectedState,
                dataItemKey: "element"
            });
            setBulkSelectedState(newBulkSelectedState);
        },
        [bulkSelectedState]
    );
    
    const emailSelected=()=>{
        setSelectedContact({});
        setBulkSelectedState({});

        console.log(selectedState);
        if (selectedState && Object.keys(selectedState).some(item => selectedState[item] === true)){
            var selContacts:atolUser[]=[];
            contacts.forEach(item=>{
                if (Object.keys(selectedState).find(selUsers => selUsers === item.userName)){
                    console.log(item);
                    selContacts.push(item);
                }
            });
            setContactsSelected(selContacts);
            togglShowEmail();
            setShowContactNote(false);
        }else{
            setContactNoteMsg("Please select a contact from the list");
            toggleShowContactNote();
        }
    }

    const setEmailType=(e:DropDownListChangeEvent)=>{
        console.log(e.value);
        //Get ads for this customer.
        var account = pageContext?.selectedAd.fileSize2||"";
        var element = pageContext?.selectedAd.element||"";
        var status="";
        if(e.value.value=="990"){
            status = pageContext?.dashStat.Dash1Status||"";        
        }
        if(e.value.value=="995"){
            status = pageContext?.atolStatuses.ProofStatuses||"";        
        }
        getAdsForBulkEmail(element,account,status).then(data=>{
            setAdsForBulk(data);
        });
        setMailMessage({...mailMessage,operation:e.value.value});
    }

    const setMessageBody = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setMailMessage({ ...mailMessage, emailBody: e.target.value });
    };

    
    
    const setSendTime=(e:DateTimePickerChangeEvent)=>{
        console.log(e.value);
        if (e.value){
            setMailMessage({...mailMessage,sendTime:e.value});
        }
    }

   
    
    const getInitialBulk=()=>{
        var account = pageContext?.selectedAd.fileSize2||"";
        var element = pageContext?.selectedAd.element||"";
        var status= pageContext?.atolStatuses.ProofStatuses||"";        
        getAdsForBulkEmail(element,account,status).then(data=>{
            setAdsForBulk(data);
        });
    }
   

    

    const sendEmail= ()=>{
        var includeAds="";
        if (Object.keys(adsForBulk).length>0){
            includeAds=JSON.stringify(adsForBulk);
        }

        if (Object.keys(selectedContact).length>0){
            var newMail:mailMessage={
                element:mailMessage.element,
                proofType:mailMessage.proofType,
                emailBody:mailMessage.emailBody,
                sendTime:mailMessage.sendTime,
                appUser:mailMessage.appUser,
                operation:mailMessage.operation,
                status:mailMessage.status,
                recipient:(selectedContact as atolUser).email,
                user:(selectedContact as atolUser).userName,
                key:(selectedContact as atolUser).apiKey,
                includeAds:includeAds
            }                
            console.log(newMail);
            sendMailMessage(newMail).then(resp=>{
                console.log(resp);
                if (resp=="200"){
                    setSendEmailVisible(false);
                }
            }); 
        }else{
            console.log(selectedState);
            contacts.forEach(item=>{
                if (Object.keys(selectedState).find(selUsers => selUsers === item.userName)){
                    console.log(item);
                    var newMail:mailMessage={
                        element:mailMessage.element,
                        proofType:mailMessage.proofType,
                        emailBody:mailMessage.emailBody,
                        sendTime:mailMessage.sendTime,
                        appUser:mailMessage.appUser,
                        operation:mailMessage.operation,
                        status:mailMessage.status,
                        recipient:item.email,
                        user:item.userName,
                        key:item.apiKey,
                        includeAds:includeAds
                    }                
                    console.log(newMail);
                    sendMailMessage(newMail).then(resp=>{
                        console.log(resp);
                        if (resp=="200"){
                            setSendEmailVisible(false);
                        }
                    }); 
                }
            });
        }
    }

    
    const EmptyCell = (props:GridHeaderCellProps) => {
        return <span />;
      };

    

    useEffect(() => {
        getContacts();
        getInitialBulk();
        showNewCustContact();
        isCommercial();
    }, []);
    return(
        <>
        {assignCSVisible?
        //Assign CS Dialog
        <Dialog title={"Assign Customer Support"} width={"25%"} onClose={hideAssignCS}>
            <DropDownList
                id="selectedCS"
                data={csList}
                dataItemKey='id'
                textField='name'
                fillMode={"outline"}
                filterable
                onFilterChange={setCSSearch}
                onChange={setSelectedCS}
            />
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={hideAssignCS}>Cancel</Button>
                <Button themeColor={"primary"} onClick={assignCS}>Save</Button>
            </DialogActionsBar>
        </Dialog>
        :null}
        {sendEmailVisible?
            //Send to Contact Dialog
            <EmailForm emailType='' onClose={togglShowEmail} selectedContact={contactsSelected} helpMe={false} readonly={false}></EmailForm>
            :null
        }
        {showContactCard?
            <UserProfileForm title={editProfileTitle} userProfile={selectedContact as atolUser} type={editProfileType} hideContactInfo={hideContactInfo} action={action}></UserProfileForm>
            :null
        }

        {showContactNote? <Notification
            type={{ style: 'warning', icon: true }}
            closable={true}
            onClose={toggleShowContactNote}
          >
            {contactNoteMsg}
        </Notification>
        :null}
        <Grid
            // data={contacts.map((item) => ({ ...item, "selected": selectedState[idGetter(item)] }))}
            data={contacts}
            dataItemKey='userName'
            selectable={{enabled: true, mode:"multiple"}}
            onSelectionChange={onSelectionChange}
            pageSize={contacts.length}
        >
            <GridToolbar>
                {showNewCustContact() ? <Button title="New Customer Contact" themeColor={'secondary'} type="button" onClick={newContactInfo} >New Customer Contact</Button> : null}
                <Button title="Assign CS" onClick={showAssignCS} themeColor={'secondary'} type="button">Assign CS</Button>
                {showEmailSelected() ?<Button title="Email Selected" themeColor={'secondary'} type="button" onClick={emailSelected}>Email Selected</Button>:null}
            </GridToolbar>
            <Column
                columnType='checkbox'
                field="selected"
                title="&nbsp;"
                width="40px"
                cells={{headerCell:EmptyCell}}
            />
            <Column
                field='fullName'
                title='Name'
            />
            <Column
                field='security'
                title='Type'
                cells={{data:formatType}}
            />
            <Column
            field='email'
            title='Email'
            />
            <Column
                field='phone'
                title='Phone'
            />
            <Column
                field='userName'
                title='User Name'
            />
            <Column
                field='userName'
                title='&nbsp;'
                cells={{data:contactButtons}}
            />
        </Grid>
        </>
    )
}